import { Component } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, map, merge, Observable } from 'rxjs';
import { UserInfo } from '../models/user-info.model';
import { UserService } from '../services/user.service';

/**
 * Application header component.
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  /**
   * Current user information.
   */
  public user$: Observable<UserInfo> = merge(this.getUser(), this.userService.me());

  /**
   * Creates an instance of component.
   *
   * @param msalService MSAL service.
   * @param msalBroadcastService MSAL event broker service.
   * @param userService User service.
   */
  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private userService: UserService) { }

  /**
   * Initiates user log out.
   */
  logout() {
    this.msalService.logout();
  }

  /**
   * Retrieves current user summary.
   *
   * @returns Current user summary.
   */
  private getUser(): Observable<UserInfo> {
    return this.msalBroadcastService.inProgress$.pipe(
      filter(status => status === InteractionStatus.None),
      map(_ => {
        return {
          name: this.getUserName(),
          roles: []
        }
      })
    );
  }

  /**
   * Retrieves current user display name.
   *
   * @returns Current user display name.
   */
  private getUserName(): string {
    const account = this.msalService.instance.getActiveAccount();

    if (account?.idTokenClaims) {
      const givenName = account.idTokenClaims['given_name'];
      const familyName = account.idTokenClaims['family_name'];

      return `${givenName} ${familyName}`.trim();
    }

    return '';
  }
}
